export default "__VITE_ASSET__Byxyh8kj__"